<template>
  <div>
    <el-table
      :data="scenicSpotOrders"
      style="width: 100%"
    >
      <el-table-column
        prop="area_name"
        label="套餐名称"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="picture_url"
        label="图片"
      >
        <template slot-scope="scope">
          <img
            v-if="scope.row.area_pic"
            :src="scope.row.area_pic"
            alt=""
            style="width:80px;height:80px"
          >
          <img
            src="../assets/zhanwei.png"
            alt=""
            v-if="!scope.row.area_pic"
            style="width:80px;height:80px"
          >
        </template>
      </el-table-column> -->
      <el-table-column
        prop="nick_name"
        label="昵称"
      >
      </el-table-column>
      <el-table-column
        prop="area_price"
        label="套餐价格"
      >
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <!-- <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total,  prev, pager, next, jumper"
        :total="total"
        style="text-align:right;margin:0 16px 10px 0;border-radius:20px"
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  data () {
    return {
      tableData: [],
      currentPage: 1,      //分页
      pagesize: 10,
      total: 0,
      ScenicSpot: '',
      scenicSpotOrders: []
    }
  },
  methods: {
    // 表格---操作的方法
    handleEdit (index, row) {
      console.log(index, row);
    },
    handleDelete (index, row) {
      console.log(index, row);
    },
    //查询列表
    findScenicSpot () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      console.log(userData, 111)
      var that = this;
      var salesInfoData = {
        area_id: userData.area_id,
        // start_date: this.startDate,
        // end_date: this.endDate,
        // month_date: that.the_date,
        count: true,
        pageindex: this.currentPage,
        pagesize: 10000
      };
      // if (this.value && this.value.length === 2) {
      //   salesInfoData.start_date = this.value[0]
      //   salesInfoData.end_date = this.value[1]
      //   salesInfoData.month_date = ''
      // }
      var salesInfoParams = {
        methodUrl: "/wechat/getOrderInfo",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          that.scenicSpotOrders = []
          // that.total = res.data.totalcount;
          //成功之后处理逻辑
          res.data.list.forEach(item => {
            console.log(item, 1234)
            var ScenicSpotInfor = new Object()
            var area_price = 0
            var ScenicSpot = item.order_lx
            // that.scenicSpotOrders.push(item.area_name)
            // that.scenicSpotOrders.push(item.nick_name)
            console.log(item.area_name, 123)

            if (ScenicSpot == 2) {
              console.log('*****************************')
              ScenicSpotInfor.area_name = item.area_name
              ScenicSpotInfor.nick_name = item.nick_name
              ScenicSpotInfor.area_pic = item.area_pic
              console.log(ScenicSpotInfor.area_name, '将套餐名称添加到数组内的对象内')
              console.log(ScenicSpotInfor.nick_name, '将套餐购买者的昵称添加到数组内的对象内')
              console.log(ScenicSpotInfor, '数组内套餐对象')
              var ScenicSpotList = item.package_info
              console.log(ScenicSpotList, 789)
              item.package_info.forEach(element => {
                var ScenicSpotId = element.area_id
                console.log(ScenicSpotId, '景区的id')
                if (ScenicSpotId == userData.area_id) {
                  ScenicSpotInfor.area_price = element.area_price
                  console.log(ScenicSpotInfor.area_price, '套餐的图片')
                  console.log(ScenicSpotInfor, '套餐数组内的对象')
                  console.log('============================')
                }
              });
              that.scenicSpotOrders.push(ScenicSpotInfor)
              console.log(that.scenicSpotOrders, '套餐的数据的数组')

            }
          });
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 分页
    handleSizeChange (val) {
      console.log(val, 123)
      this.pagesize = val;
      this.findScenicSpot();
    },
    handleCurrentChange (val) {
      console.log(val, 123123)
      this.currentPage = val;
      this.findScenicSpot();
    },
  },
  mounted () {
    this.findScenicSpot()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PackageOrders.vue